export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_ellipse-ea1dda65ff61b93ccdacf6e41bc07cfd.png";